var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vehicle)?_c('div',{staticClass:"vehicle-usages"},[_c('report-usages-list',{attrs:{"show-no-energy":"","vehicle-id":_vm.vehicle.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }